import { Controller } from "@hotwired/stimulus";

type PriorityLabel = "low" | "normal" | "high" | "urgent";

export default class extends Controller<HTMLElement> {
  static targets = ["input", "label", "score"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly labelTarget: HTMLElement;
  declare readonly scoreTarget: HTMLElement;

  connect() {
    this.update();
  }

  update() {
    const priorityLabel = this.priorityLabelFor(this.inputTarget.value);
    this.labelTarget.textContent = priorityLabel;
    this.labelTarget.className = `priority ${priorityLabel}`;
    this.scoreTarget.textContent = this.inputTarget.value;
  }

  private priorityLabelFor(score: string): PriorityLabel {
    const numericScore = Number.parseInt(score, 10) || 0;
    if (numericScore >= 90) return "urgent";
    if (numericScore >= 70) return "high";
    if (numericScore >= 30) return "normal";
    return "low";
  }
}
